import {
  CCT_ECG_TABLE_DATA_REQUEST,
  CCT_ECG_TABLE_DATA_SUCCESS,
  CCT_ECG_TABLE_DATA_FAILURE,
  CCT_SELECTED_PATIENT,
  CCT_SELECTED_RECORDING,
} from './types';

const initialState = {
  recordings: {
    isFetching: false,
    data: [],
    error: {},
  },
  selectedPatinet: {},
  selectedRecording: {},
};

// ------------------------------------
// Action Handlers
// ------------------------------------
const ACTION_HANDLERS = {
  [CCT_ECG_TABLE_DATA_REQUEST]: (state, action) => ({
    ...state,
    recordings: {
      isFetching: true,
      data: [],
      error: {},
    },
  }),
  [CCT_ECG_TABLE_DATA_SUCCESS]: (state, action) => ({
    ...state,
    recordings: {
      isFetching: false,
      data: action.payload,
      error: {},
    },
  }),
  [CCT_ECG_TABLE_DATA_FAILURE]: (state, action) => ({
    ...state,
    recordings: {
      isFetching: false,
      data: [],
      error: 'failed',
    },
  }),
  [CCT_SELECTED_PATIENT]: (state, action) => ({
    ...state,
    selectedPatinet: action.payload,
  }),
  [CCT_SELECTED_RECORDING]: (state, action) => ({
    ...state,
    selectedRecording: action.payload,
  }),
};

//
// Reducer
// ------------------------------------
export const KardiaRxCCTEcgTable = (state = initialState, action) => {
  const handler = ACTION_HANDLERS[action.type];
  return handler ? handler(state, action) : state;
};



// WEBPACK FOOTER //
// ./src/views/state/KardiaRxCCTPatient/KardiaRxCCTEcgTableReducers.js